import { useNavigate } from "react-router-dom";
import images from "./../../../images";

const Logo = () => {
  const navigate = useNavigate();
  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate("/quest", { state: { direction: -1 }, replace: true })}
    >
      <img src={images.v6Logo} alt="Rally Logo" className="w-[100px] h-[11px] object-contain" />
    </div>
  );
};

export default Logo;
